const DEEPGRAM_API = process.env.VUE_APP_DEEPGRAM_API_KEY

export async function speakWithDeepgram(text) {
  if (!text || typeof text !== 'string') return

  const TTS_URL = 'https://api.deepgram.com/v1/speak?model=aura-2-thalia-en&encoding=mp3&bit_rate=32000'
  try {
    const cleanedText = text.replace(/\bPIA\b/gi, 'Pia')

    const res = await fetch(TTS_URL, {
      method: 'POST',
      headers: {
        Authorization: `Token ${DEEPGRAM_API}`,
        'Content-Type': 'application/json',
        Accept: 'audio/wav', // linear16 = PCM WAV
      },
      body: JSON.stringify({ text: cleanedText }),
    })

    if (!res.ok) {
      const errText = await res.text()
      throw new Error(`TTS failed: ${res.status} ${errText}`)
    }

    const blob = await res.blob()
    const audioUrl = URL.createObjectURL(blob)
    const audio = new Audio(audioUrl)
    audio.play()

    return audio
  } catch (err) {
    console.error('❌ Deepgram TTS error:', err.message || err)
  }
}
